'use client';

import { c as _c } from "react/compiler-runtime";
import { SUBSCRIPTION, type Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import { cn } from '@algoacademy/design-system/shared/cn';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H2 } from '@algoacademy/design-system/web/marketing/typography/Heading/H2';
import { useState } from 'react';
import { MENTORING_TABS, MentoringTabs } from './_components/MentoringTabs';
import { PricingCard } from './_components/PricingCard';
import { SubscriptionTabs } from './_components/SubscriptionTabs';
import { GroupMentoring } from './Mentoring/GroupMentoring';
import { IndividualMentoring } from './Mentoring/IndividualMentoring';
import { ProjectMentoring } from './Mentoring/ProjectMentoring';
import { useMentoringProducts } from './Mentoring/useMentoringProducts';
export function MentoringPricing(t0) {
  const $ = _c(42);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    defaultMentoringTab: t2,
    goalPage: t3
  } = t1;
  const defaultMentoringTab = t2 === undefined ? MENTORING_TABS.GROUP : t2;
  const goalPage = t3 === undefined ? false : t3;
  const [activeSubscriptionTab, setActiveSubscriptionTab] = useState(SUBSCRIPTION.PER_4_WEEKS);
  const [activeMentoringTab, setActiveMentoringTab] = useState(defaultMentoringTab);
  const {
    individualProduct,
    setIndividualProduct,
    groupProduct,
    projectProduct
  } = useMentoringProducts(activeSubscriptionTab);
  const currentProduct = activeMentoringTab === MENTORING_TABS.INDIVIDUAL ? individualProduct : activeMentoringTab === MENTORING_TABS.PROJECT ? projectProduct : groupProduct;
  const t4 = goalPage && "text-white";
  let t5;
  if ($[2] !== t4) {
    t5 = cn(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = goalPage ? "Tw\xF3j mentoring" : "Wybierz mentoring idealny dla Ciebie";
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = <H2 id="mentoring-pricing-heading" className={t5}>{t6}</H2>;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== activeMentoringTab || $[8] !== goalPage) {
    t8 = !goalPage ? <><VerticalSpacer size="content" /><MentoringTabs tabs={Object.values(MENTORING_TABS) as MENTORING_TABS[]} activeTab={activeMentoringTab} setActiveTab={setActiveMentoringTab} /></> : null;
    $[7] = activeMentoringTab;
    $[8] = goalPage;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <div className="flex min-w-0 flex-col items-center text-center">{t7}{t8}</div>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <VerticalSpacer size="content" />;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== activeMentoringTab || $[15] !== activeSubscriptionTab || $[16] !== goalPage || $[17] !== individualProduct || $[18] !== setIndividualProduct) {
    t11 = <div className="w-full">{activeMentoringTab === MENTORING_TABS.INDIVIDUAL ? <IndividualMentoring activeSubscriptionTab={activeSubscriptionTab} individualMentoringProduct={individualProduct} setIndividualMentoringProduct={setIndividualProduct} goalPage={goalPage} /> : activeMentoringTab === MENTORING_TABS.PROJECT ? <ProjectMentoring goalPage={goalPage} /> : <GroupMentoring goalPage={goalPage} />}</div>;
    $[14] = activeMentoringTab;
    $[15] = activeSubscriptionTab;
    $[16] = goalPage;
    $[17] = individualProduct;
    $[18] = setIndividualProduct;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = goalPage && "dark";
  let t13;
  if ($[20] !== t12) {
    t13 = cn("top-8 right-0 block w-full shrink-0 rounded-lg lg:sticky lg:w-sm", t12);
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <legend className="w-full text-contentSecondary text-sm leading-6 xl:text-base xl:leading-7">Typ subskrypcji</legend>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = Object.values(SUBSCRIPTION);
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== activeSubscriptionTab || $[25] !== goalPage) {
    t16 = <fieldset className="m-0 max-w-full space-y-2 border-0 p-0 text-center">{t14}<SubscriptionTabs tabs={t15 as Subscription[]} activeTab={activeSubscriptionTab} setActiveTab={setActiveSubscriptionTab} goalPage={goalPage} /></fieldset>;
    $[24] = activeSubscriptionTab;
    $[25] = goalPage;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== currentProduct || $[28] !== goalPage) {
    t17 = <PricingCard mentoringProduct={currentProduct} goalPage={goalPage} />;
    $[27] = currentProduct;
    $[28] = goalPage;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t16 || $[31] !== t17) {
    t18 = <div className="flex flex-col items-center gap-8">{t16}{t17}</div>;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t13 || $[34] !== t18) {
    t19 = <LightCard className={t13}>{t18}</LightCard>;
    $[33] = t13;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t11 || $[37] !== t19) {
    t20 = <div className="relative flex flex-col justify-between gap-8 lg:flex-row">{t11}{t19}</div>;
    $[36] = t11;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t20 || $[40] !== t9) {
    t21 = <section id="wybierz-mentoring-idealny-dla-ciebie" aria-labelledby="mentoring-pricing-heading">{t9}{t10}{t20}</section>;
    $[39] = t20;
    $[40] = t9;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  return t21;
}